'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  text-align: center;\n  font-weight: normal;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex-direction: row;\n  justify-content: space-between;\n  .pagination {\n    list-style-type: none;\n    padding: 0;\n\n    li {\n      display: inline;\n      border: 1px solid ', ';\n      padding: 6px 0px;\n      margin: 0 5px;\n      border-radius: 2px;\n\n      &.previous,\n      &.next {\n        position: relative;\n        background: ', ';\n        font-family: ', ';\n        padding: 6px 16px 5px;\n        border: 1px solid ', ';\n        border-radius: 4px;\n        text-decoration: none;\n        display: inline-block;\n        outline: none;\n        margin: 0px 30px;\n\n        font-size: 14px;\n\n        transition: border-color 0.1s ease-in-out;\n        a {\n          color: ', ';\n          padding: 0px;\n        }\n\n        &:hover {\n          border: 1px solid ', ';\n        }\n      }\n\n      &.active {\n        background: ', ';\n        border: 0px;\n        a {\n          color: ', ';\n          font-family: ', ';\n        }\n\n        &:hover {\n          border: 0px;\n        }\n      }\n\n      &.disabled {\n        opacity: 0.3;\n        a {\n          cursor: initial !important;\n        }\n        &:hover {\n          border-color: ', ';\n        }\n      }\n\n      a {\n        text-decoration: none;\n        cursor: pointer;\n        outline: none;\n        font-size: 12px;\n        color: ', ';\n        padding: 12px;\n      }\n\n      &.ellipsis-style {\n        border: 0px;\n        padding: 0;\n        outline: none;\n        a {\n          cursor: auto;\n        }\n        &:hover {\n          border: 0px;\n        }\n      }\n\n      &:hover {\n        border: 1px solid ', ';\n      }\n    }\n  }\n\n  .previous {\n    &:before {\n      ', '\n      font-size: 8px;\n    }\n  }\n  .next {\n    &:after {\n      ', '\n      font-size: 8px;\n    }\n  }\n'], ['\n  width: 100%;\n  text-align: center;\n  font-weight: normal;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex-direction: row;\n  justify-content: space-between;\n  .pagination {\n    list-style-type: none;\n    padding: 0;\n\n    li {\n      display: inline;\n      border: 1px solid ', ';\n      padding: 6px 0px;\n      margin: 0 5px;\n      border-radius: 2px;\n\n      &.previous,\n      &.next {\n        position: relative;\n        background: ', ';\n        font-family: ', ';\n        padding: 6px 16px 5px;\n        border: 1px solid ', ';\n        border-radius: 4px;\n        text-decoration: none;\n        display: inline-block;\n        outline: none;\n        margin: 0px 30px;\n\n        font-size: 14px;\n\n        transition: border-color 0.1s ease-in-out;\n        a {\n          color: ', ';\n          padding: 0px;\n        }\n\n        &:hover {\n          border: 1px solid ', ';\n        }\n      }\n\n      &.active {\n        background: ', ';\n        border: 0px;\n        a {\n          color: ', ';\n          font-family: ', ';\n        }\n\n        &:hover {\n          border: 0px;\n        }\n      }\n\n      &.disabled {\n        opacity: 0.3;\n        a {\n          cursor: initial !important;\n        }\n        &:hover {\n          border-color: ', ';\n        }\n      }\n\n      a {\n        text-decoration: none;\n        cursor: pointer;\n        outline: none;\n        font-size: 12px;\n        color: ', ';\n        padding: 12px;\n      }\n\n      &.ellipsis-style {\n        border: 0px;\n        padding: 0;\n        outline: none;\n        a {\n          cursor: auto;\n        }\n        &:hover {\n          border: 0px;\n        }\n      }\n\n      &:hover {\n        border: 1px solid ', ';\n      }\n    }\n  }\n\n  .previous {\n    &:before {\n      ', '\n      font-size: 8px;\n    }\n  }\n  .next {\n    &:after {\n      ', '\n      font-size: 8px;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPaginate = require('react-paginate');

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Font = require('./Font');

var _Font2 = _interopRequireDefault(_Font);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.color.base2;
}, function (props) {
  return props.theme.color.secondary;
}, _Font2.default, _Font2.default);

Container.displayName = 'Container';

var NitroDataGridPagination = function (_Component) {
  _inherits(NitroDataGridPagination, _Component);

  function NitroDataGridPagination() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NitroDataGridPagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NitroDataGridPagination.__proto__ || Object.getPrototypeOf(NitroDataGridPagination)).call.apply(_ref, [this].concat(args))), _this), _this.pageChange = function (event) {
      _this.props.setPage(parseInt(event.target.getAttribute('data-value'), 10));
    }, _this.handlePageClick = function (data) {
      _this.props.setPage(parseInt(data.selected, 10));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NitroDataGridPagination, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rowPerPage = _props.rowPerPage,
          totalCount = _props.totalCount,
          currentPage = _props.currentPage;

      var offset = 1;
      var count = rowPerPage;

      if (currentPage !== 0) {
        offset += rowPerPage * currentPage;
        count = rowPerPage * currentPage + rowPerPage;
      }
      if (count > totalCount) {
        count = totalCount;
      }
      var maxPages = Math.ceil(totalCount / rowPerPage);

      var prev = function prev() {
        return _react2.default.createElement(
          'svg',
          { width: '16', height: '16', viewBox: '0 0 16 16' },
          _react2.default.createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2.default.createElement('path', {
              stroke: '#A4ABB7',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2',
              d: 'M8.333 8.333L2.667 14m0-11.333l5.666 5.666M12.3 2.667V14',
              transform: 'matrix(-1 0 0 1 16 0)'
            })
          )
        );
      };
      var next = function next() {
        return _react2.default.createElement(
          'svg',
          { width: '16', height: '16', viewBox: '0 0 16 16' },
          _react2.default.createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2.default.createElement('path', {
              stroke: '#A4ABB7',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '2',
              d: 'M8.333 8.333L2.667 14m0-11.333l5.666 5.666M12.3 2.667V14'
            })
          )
        );
      };
      return _react2.default.createElement(
        Container,
        null,
        typeof offset === 'number' && typeof count === 'number' && typeof totalCount === 'number' && _react2.default.createElement(
          'div',
          null,
          'Showing ',
          offset,
          ' to ',
          count,
          ' of ',
          totalCount,
          ' entries'
        ),
        maxPages > 1 && _react2.default.createElement(_reactPaginate2.default, {
          previousLabel: prev(),
          nextLabel: next(),
          breakLabel: _react2.default.createElement(
            'a',
            null,
            '...'
          ),
          breakClassName: 'ellipsis-style',
          pageCount: maxPages,
          marginPagesDisplayed: 0,
          forcePage: currentPage,
          pageRangeDisplayed: 4,
          onPageChange: this.handlePageClick,
          containerClassName: 'pagination',
          subContainerClassName: 'pages pagination',
          activeClassName: 'active',
          previousClassName: 'previous',
          nextClassName: 'next'
        })
      );
    }
  }]);

  return NitroDataGridPagination;
}(_react.Component);

NitroDataGridPagination.propTypes = {
  previous: _propTypes2.default.func,
  next: _propTypes2.default.func,
  setPage: _propTypes2.default.func,
  currentPage: _propTypes2.default.number,
  totalCount: _propTypes2.default.number,
  resultsPerPage: _propTypes2.default.number
};

exports.default = NitroDataGridPagination;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-data-grid/NitroDataGridPagination.js
// module id = 2899
// module chunks = 4